import type {AiChatGeneratedAsset} from '@AiChat/ai-chat.types';
import type {ChatMessage} from '@Components/ai-chat-window/ai-chat-window.types';

export interface AiChatAssetsImagePreviewProps {
  asset: AiChatGeneratedAsset;
  onClose: VoidFunction;
}

export const IMAGE_PREVIEW_INDEX = 0;
export const IMAGE_PREVIEW_NO_MESSAGES: Record<string, ChatMessage> = {};
